export default (path) => {
  if(path){
    return path;
  }
  return 'https://api.agendaenlinea.cl/image/default_avatar.png';
}



// WEBPACK FOOTER //
// ./src/filters/formatPath.js